import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';
import { AwsProvider } from '../../providers/aws/aws';
import { UsersProvider } from '../../providers/users/users';
import { AddUserPage } from '../add-user/add-user';
import { UserOverviewPage } from '../user-overview/user-overview';
import { LoginPage } from '../login/login';

@IonicPage()
@Component({
  selector: 'page-user-management',
  templateUrl: 'user-management.html',
})
export class UserManagementPage {

  queryText: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public aws: AwsProvider, public alertCtrl: AlertController, public loadingCtrl: LoadingController, public usersPro: UsersProvider) {
  }

  ionViewDidEnter() {
    this.usersPro.populateUsers(false,true);
  }

  searchByKeyword(searchEvent) {
    const searchTerm = searchEvent.target.value;
    this.usersPro.search(searchTerm, true);
  }

  /**
   * Sort table depending on which column was clicked on
   * @param key object key to sort on
   */
  sortUserTable(key) {
    // return if not enough entries
    if (!this.usersPro.users || this.usersPro.users.length < 2) {
      return
    }

    // set current sort field to key
    this.usersPro.userField = key;

    // get current order of column as a string
    let order: String = JSON.stringify(this.usersPro.users.map(item => item[key]));

    // sort ascendingly
    this.usersPro.users.sort((a, b) => {
      if (typeof a[key] == 'number') {
        if (a[key] < b[key]) return -1;
        else if (a[key] > b[key]) return 1;
        else return 0;
      } else {
        if (a[key].toLowerCase() < b[key].toLowerCase()) return -1;
        else if (a[key].toLowerCase() > b[key].toLowerCase()) return 1;
        else return 0;
      }
    });

    // check to see if order changed at all
    // if order did not change, it's already sorted. Do descending instead
    let newOrder: String = JSON.stringify(this.usersPro.users.map(item => item[key]));
    if (order == newOrder) {
      this.usersPro.userSym = '▼';
      this.usersPro.users.sort((a, b) => {
        if (typeof a[key] == 'number') {
          if (a[key] < b[key]) return 1;
          else if (a[key] > b[key]) return -1;
          else return 0;
        } else {
          if (a[key].toLowerCase() < b[key].toLowerCase()) return 1;
          else if (a[key].toLowerCase() > b[key].toLowerCase()) return -1;
          else return 0;
        }
      });
    } else {
      this.usersPro.userSym = '▲'
    }
  }

  addUser() {
  	this.navCtrl.setRoot(AddUserPage);
  }

  refresh(){
    this.usersPro.populateUsers(true, true);
  }

  goToUser(user) {
    this.navCtrl.push(UserOverviewPage, { 'user': user });
  }

  logOut() {
    this.aws.signOut().then(() => {
      this.navCtrl.setRoot(LoginPage);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/user-management/user-management.ts